import { render, staticRenderFns } from "./loader-flipDelay.vue?vue&type=template&id=b852f970&scoped=true&"
import script from "./loader-flipDelay.vue?vue&type=script&lang=js&"
export * from "./loader-flipDelay.vue?vue&type=script&lang=js&"
import style0 from "./loader-flipDelay.vue?vue&type=style&index=0&id=b852f970&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b852f970",
  null
  
)

export default component.exports